export default __webpack_public_path__ + "static/media/zchn_mtblls.5bd6c746.jpg";